import { defineMessages } from "react-intl";

export const occupationTypesMessages = defineMessages({
  title: {
    id: "occupancyTypes.title",
    defaultMessage: "Occupancy types",
  },
  optionTypeWithoutFilter: {
    id: "occupancyTypes.options.withoutFilter",
    defaultMessage: "Without filter",
  },
  optionTypePerPerson: {
    id: "occupancyTypes.options.perPerson",
    defaultMessage: "Per persons",
  },
  optionTypeForAdultsChildren: {
    id: "occupancyTypes.options.adultsChildren",
    defaultMessage: "For adults and children",
  },
  optionTypeForAdultsChildrenBabies: {
    id: "occupancyTypes.options.adultsChildrenBabies",
    defaultMessage: "For adults, children and babies",
  },
  optionTypeForAdultsTeensChildren: {
    id: "occupancyTypes.options.adultsTeensChildren",
    defaultMessage: "For adults, juniors and children",
  },
  optionTypeForAdultsTeensChildrenBabies: {
    id: "occupancyTypes.options.adultsTeensChildrenBabies",
    defaultMessage: "For adults, juniors, children and babies",
  },
  optionTypeForSeniorsAdultsTeensChildrenBabies: {
    id: "occupancyTypes.options.seniorsAdultsTeensChildrenBabies",
    defaultMessage: "For seniors, adults, juniors, children and babies",
  },

  occupancyFilterType: {
    id: "occupancyTypes.form.occupancyFilterType",
    defaultMessage: "Search filter",
  },
  minChildrenAge: {
    id: "occupancyTypes.form.minChildrenAge",
    defaultMessage: "Min. Children age",
  },
  maxChildrenAge: {
    id: "occupancyTypes.form.maxChildrenAge",
    defaultMessage: "Max. Children age",
  },
  minBabiesAge: {
    id: "occupancyTypes.form.minBabiesAge",
    defaultMessage: "Min. Babies age",
  },
  maxTeensAge: {
    id: "occupancyTypes.form.maxTeensAge",
    defaultMessage: "Max. Juniors age",
  },
  maxAdultsAge: {
    id: "occupancyTypes.form.maxAdultsAge",
    defaultMessage: "Max. Adults age",
  },
  filterGuestsByAge: {
    id: "occupancyTypes.form.filterGuestsByAge",
    defaultMessage: "Filter by age",
  },

  save: {
    id: "default.save",
    defaultMessage: "Save",
  },

  saveSuccess: {
    id: "occupancyTypes.messages.saveSuccess",
    defaultMessage: "The configuration saved correctly",
  },
  saveError: {
    id: "occupancyTypes.messages.saveError",
    defaultMessage: "An error occurred, try again",
  },
  errorMinChildrenAgeGreaterMaxChildrenAge: {
    id: "occupancyTypes.messages.errorMinChildrenAgeGreaterMaxChildrenAge",
    defaultMessage: "Min. children age can not be greater than Max. children age",
  },
  errorMaxChildrenAgeGreaterMaxTeensAge: {
    id: "occupancyTypes.messages.errorMaxChildrenAgeGreaterMaxTeensAge",
    defaultMessage: "Max. children age can not be greater than Max. teens age",
  },
  errorMinBabiesAgeGreaterMinChildrenAge: {
    id: "occupancyTypes.messages.errorMinBabiesAgeGreaterMinChildrenAge",
    defaultMessage: "Min. babies age can not be greater than Min. children age",
  },
  occupationType: {
    id: "occupancyTypes.form.occupancyType",
    defaultMessage: "Daily rate calculation model",
  },
  occupancyTypeMode: {
    id: "occupancyTypes.form.occupancyTypeMode",
    defaultMessage: "By inventory line",
  },
  paxTypeMode: {
    id: "occupancyTypes.form.paxTypeMode",
    defaultMessage: "By accommodation",
  },
  baseAccommodationType: {
    id: "occupancyTypes.form.baseAccommodationType",
    defaultMessage: "Base accommodation type",
  },
  baseAccommodationTypePax: {
    id: "occupancyTypes.form.baseAccommodationTypePax",
    defaultMessage: "Per person (all pax types)",
  },
  baseAccommodationTypeAdults: {
    id: "occupancyTypes.form.baseAccommodationTypeAdults",
    defaultMessage: "Adults only",
  },
});

export const occupationTypesErrorMessages = defineMessages({
  OCCUPATION_LINES_IN_USE: {
    id: "occupancyTypes.form.occupationLinesInUse",
    defaultMessage:
      "There are inventory lines created. To activate this occupancy model, you must first delete all existing inventory lines.",
  },
});
